import { useCallback } from "react"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { GetRequest } from "../../services/ApiClientService"

export type OrderFulfillmentCounters = {
  fulfillmentOpenOrdersCount: number
  secondaryOpenOrdersCount: number
  delayedOpenOrdersCount: number
}

const emptyCounters: OrderFulfillmentCounters = {
  fulfillmentOpenOrdersCount: 0,
  secondaryOpenOrdersCount: 0,
  delayedOpenOrdersCount: 0,
}

export const useGetOrderFulfillmentCounters = () => {
  const handleGetOrderFulfillmentCounters = useCallback(async (): Promise<OrderFulfillmentCounters> => {
    const response = await GetRequest<OrderFulfillmentCounters>(API_ROUTES.ORDER.GET_FULFILLMENT_COUNTERS)

    return response.success ? (response.data ?? emptyCounters) : emptyCounters
  }, [])

  return { handleGetOrderFulfillmentCounters }
}
